import React, { useEffect, useRef, useState } from 'react'
import DropDownBar from './dropDownBar';
import { Link, useLocation } from 'react-router-dom';
import logoEscudo from "../images/logoEscudo.png";
import { GEOLINK, OBSERVATORYLINK } from '../config';

const NavBar = ({decryptSession, decryptUserRole, logOut, setIsModalLogInOpen, setIsModalSignUpOpen}) => {
    const navBarRef = useRef(null);
    const [ location, setLocation ] = useState(useLocation().pathname);
    const [ open, setOpen ] = useState();
    const [ openDropDownBar, setOpenDropDownBar ] = useState(0);
    let location1 = useLocation().pathname;
   
    const bodyStyle = document.body.style

    useEffect(()=>{   
            bodyStyle.overflow = open ? 'hidden': 'auto';
            
    },[open])


    useEffect(()=>{
        setLocation(location1)
       
    },[useLocation().pathname])

    const handleOpenDropDownBar = (value) => {
        setOpenDropDownBar(openDropDownBar === value ? -1 : value);
    };

    return (
        <>
            <div className='2sm:hidden h-full items-center flex'>
                <button className='float-left' onClick={() => {navBarRef.current.classList.remove('hidden'); setOpen(true)}}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  stroke="currentColor" class="w-12 h-12 ">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5" />
                    </svg>
                </button>
            </div>
            <nav ref={navBarRef} class=" backdrop-blur-sm w-full h-full fixed 2sm:static left-0 right-0 top-0 lg:h  flex flex-col 2sm:flex-row  2sm:items-center 2sm:bg-navBar text-sm 2sm:text-[12px] lg:text-sm  2sm:justify-center 2sm:h-14 text-black hidden  2sm:flex md:mx-0 " >
                <div className='flex fixed z-10 2sm:flex-row rounded flex-col px-5 bg-white 2sm:w-[675px] md:w-[700px] lg:w-[800px]  2md:right-0 h-full  2sm:justify-between 2sm:flex w-[300px] 2sm:items-center sm:mx-0  '>
                    <div className='2sm:hidden mt-5 mb-4'>
                        <button className='float-left py-2.5' onClick={() => {setOpenDropDownBar(0);navBarRef.current.classList.add('hidden');setOpen(false);}}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  stroke="currentColor" class="w-12 h-12 ">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5" />
                            </svg>
                        </button>
                        <div className=" flex grow py-2.5 items-center ">
                            <a href="https://www.alcaldianeiva.gov.co/" target="_blank" rel="noreferrer" className=''>
                                <img className="h-[50px] " src={logoEscudo} alt="Logo escudo Neiva" />
                            </a>
                        </div>

                    </div>
                    <Link to="/" className="md:py-0 md:px-2 md:text-center border-t-2 2sm:border-t-0"><div className={`${location === "/" ? "navActive": "navStyle"}`}>INICIO</div></Link>
                    <Link to="/catastro" className='md:py-0 md:px-2  md:text-center'><div className={`h-full ${location === "/catastro" ? "navActive": "navStyle"}`}>¿QUIENES SOMOS? </div></Link>
                    <DropDownBar id='1' handleOpenDropDownBar={handleOpenDropDownBar} openDropDownBar={openDropDownBar} labelText='TRANSPARENCIA' location={location}>
                        {/* <Link to="/catastro" class="block py-3 hover:bg-bgHoverGray p-2" >DIRECCION DE GESTION CATASTRAL</Link> */}
                        <Link to="/normatividad" class="block 2sm:py-2" ><div className={`border-t-2 2sm:border-t-0 ${location === "/normatividad" ? "subNavActive": "subNavStyle"}`}>NORMATIVIDAD</div></Link>
                        <Link to="/funciones" class="block 2sm:py-2" ><div className={`${location === "/funciones" ? "subNavActive": "subNavStyle"}`}>FUNCIONES DGC</div></Link>
                        <Link to="/navegabilidad" class="block 2sm:py-2" ><div className={`${location === "/navegabilidad" ? "subNavActive": "subNavStyle"}`}>NAVEGABILIDAD</div></Link>
                    </DropDownBar>
                    <DropDownBar id='2' handleOpenDropDownBar={handleOpenDropDownBar} openDropDownBar={openDropDownBar} labelText='ATENCIÓN Y SERVICIOS' location={location}>
                        <Link to="/tramites" class="block 2sm:py-2 truncate"><div className={`border-t-2 2sm:border-t-0 ${location === "/tramites" ? "subNavActive": "subNavStyle"}`}>TRÁMITES Y PRODUCTOS</div></Link>
                        <Link to="/deberesdelciudadano" class="block 2sm:py-2 truncate"><div className={`${location === "/deberesdelciudadano" ? "subNavActive": "subNavStyle"}`}>DEBERES DEL CIUDADANO</div></Link>
                        <Link to="/contactenos" class="block truncate 2sm:py-2"><div className={`${location === "/contactenos" ? "subNavActive": "subNavStyle"}`}>CONTÁCTENOS</div></Link>
                        <Link to="/preguntasfrecuentes" class="block 2sm:py-2 truncate"><div className={`${location === "/preguntasfrecuentes" ? "subNavActive": "subNavStyle"}`}>PREGUNTAS FRECUENTES</div></Link>
                    </DropDownBar>
                    <DropDownBar id='3' handleOpenDropDownBar={handleOpenDropDownBar} openDropDownBar={openDropDownBar} labelText='GEOSERVICIOS' location={location}>
                        <Link to="/datosabiertos" className='block truncate 2sm:py-2'><div className={`border-t-2 2sm:border-t-0 ${location === "/datosabiertos" ? "subNavActive": "subNavStyle"}`}>DATOS ABIERTOS</div></Link>
                        <a href={GEOLINK} target="_blank" rel="noopener noreferrer" className='block truncate 2sm:py-2'><div className={`border-t-2 2sm:border-t-0 ${location === "/geoportal" ? "subNavActive": "subNavStyle"}`}>GEOPORTAL</div></a>
                        <a href={OBSERVATORYLINK} target="_blank" rel="noopener noreferrer" className="block 2sm:py-2 truncate"><div className={`${location === "/observatorioinmobiliario" ? "subNavActive": "subNavStyle"}`}>OBSERVATORIO INMOBILIARIO</div></a>
                        {/* <Link to="/observatorio" class="block 2sm:py-2 truncate"><div className={`${location === "/observatorio" ? "subNavActive": "subNavStyle"}`}>OBSERVATORIO INMOBILIARIO</div></Link> */}
                    </DropDownBar>
                    <Link to="/participa" className="md:py-0 md:px-2 md:text-center"><div className={`${location === "/participa" ? "navActive": "navStyle"}`}>PARTICIPA</div></Link>                    
                    <div className='2sm:hidden mt-8'>
                    {(decryptSession() === "true") ? (
          
          <div className="flex gap-3 flex-col relative  pl-5 ">
             {decryptUserRole() === "1" && (
               <button onClick={() => window.location.assign("/control")} className="flex items-center text-[#0eaf58] font-bold text-base">
                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
                   <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
                 </svg>
                 Panel de Control
               </button>)
             }
             <button onClick={() => window.location.assign("/perfil")} className=" flex items-center text-[#0eaf58] font-bold text-base">
               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
                 <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
               </svg>
               Mi Perfil
             </button>
             <button onClick={() => logOut()} className=" flex items-center text-[#0eaf58] font-bold text-base">
               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
                 <path stroke-linecap="round" stroke-linejoin="round" d="M5.636 5.636a9 9 0 1012.728 0M12 3v9" />
               </svg>
               Cerrar Sesión
             </button>
         </div>
       ) : (
         <div className="flex gap-3 flex-col relative  pl-5 ">
           <button onClick={() => setIsModalSignUpOpen(true)} className="flex items-center text-[#0eaf58] font-bold text-base">
             <svg
               xmlns="http://www.w3.org/2000/svg"
               fill="none"
               viewBox="0 0 24 24"
               stroke-width="1.5"
               stroke="currentColor"
               class="w-6 h-6 mr-1">
               <path
                 stroke-linecap="round"
                 stroke-linejoin="round"
                 d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
             </svg>
             Registrate
           </button>

           <button onClick={() => setIsModalLogInOpen(true)} className=" flex items-center text-[#0eaf58] font-bold text-base">
             <svg
               xmlns="http://www.w3.org/2000/svg"
               fill="none" viewBox="0 0 24 24"
               stroke-width="1.5"
               stroke="currentColor"
               class="w-6 h-6 mr-1">
               <path
                 stroke-linecap="round"
                 stroke-linejoin="round"
                 d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
             </svg>
             Iniciar Sesión
           </button>
         </div>)}
         </div>
                </div>
                
                <div className={`2sm:hidden 2sm:${bodyStyle.overflowY='scroll'}  fixed w-full h-full flex left-0 right-0 z-0`} onClick={() => {navBarRef.current.classList.add('hidden');setOpen(false);setOpenDropDownBar(0)}}>
                    
                </div>
            </nav>
            
        </>
    );
}
export default NavBar;